import names from '@/data/taxonomy-names.json';
import type { UiLang } from './i18n';

/** DB'deki kategori adları Türkçe; arayüz dili için mobil sözlükten çeviri. */
const DICT = names as Record<UiLang, Record<string, string>>;

export function categoryLabel(lang: UiLang, slug: string | null | undefined, fallback = ''): string {
  if (!slug) return fallback;
  return DICT[lang]?.[`cat_${slug.replace(/-/g, '_')}`] ?? fallback;
}

export function subcategoryLabel(lang: UiLang, slug: string | null | undefined, fallback = ''): string {
  if (!slug) return fallback;
  return DICT[lang]?.[`sub_${slug.replace(/-/g, '_')}`] ?? fallback;
}

/** Dikey başına vurgu rengi (mobildeki CategoryColors ile aynı). */
export const CATEGORY_COLORS: Record<string, string> = {
  marketing: '#EC4899',
  product: '#6366F1',
  engineering: '#0EA5E9',
  'data-ai': '#8B5CF6',
  design: '#F59E0B',
  sales: '#10B981',
  finance: '#059669',
  leadership: '#EF4444',
  entrepreneurship: '#F97316',
  operations: '#64748B',
  people: '#14B8A6',
  growth: '#A855F7',
  business: '#2E4E86',
};

export function categoryColor(slug: string | null | undefined): string {
  return (slug && CATEGORY_COLORS[slug]) || '#6366F1';
}
